import React from 'react';
import { Puzzle, ClipboardList } from 'lucide-react';
import { useBizMode } from '../utils/bizMode';

// 顶部业务切换：排五 / 证券（分段控件，样式与教程弹层的标签页一致）
// 用法：<BizSwitch />（自己读写全局业务选择）；也可传 value/onChange 做受控。
export default function BizSwitch({ value, onChange, style }) {
  const [mode, setMode] = useBizMode();
  const cur = value || mode;
  const change = onChange || setMode;
  const items = [
    { key: 'legacy', label: '排五', Icon: ClipboardList },
    { key: 'puzzle', label: '证券', Icon: Puzzle },
  ];
  return (
    <div style={{ display: 'flex', gap: 6, padding: 4, background: 'var(--c-surface)', borderRadius: 12, boxShadow: 'var(--shadow-sm)', ...style }}>
      {items.map(({ key, label, Icon }) => {
        const active = cur === key;
        return (
          <button
            key={key}
            onClick={() => change(key)}
            style={{
              flex: 1, height: 36, borderRadius: 9, border: 'none', cursor: 'pointer',
              background: active ? 'var(--c-primary)' : 'transparent',
              color: active ? '#fff' : 'var(--c-text-secondary)',
              fontSize: 14, fontWeight: active ? 700 : 500,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
              transition: 'all .15s',
            }}
          >
            <Icon size={15} /> {label}
          </button>
        );
      })}
    </div>
  );
}
